import { styled, apply } from 'lib/styled'

const Container = styled.div(apply('flex h-full items-center justify-center'), {
  background: 'linear-gradient(322.07deg, #FFFFFF 22.99%, #EFF9FF 78.54%)',
})

const ClaimCompanyLayout = ({ children }) => <Container>{children}</Container>

export { ClaimCompanyLayout }
